<template>
    <div>
        <div class="w-full flex justify-between border-b-gray-500 text-gray-500 tracking-widest">
            <div>
                URL
            </div>
            <div><span class="text-3xl text-yellow-600" v-if="hasUnsavedChanges">•</span></div>
        </div>
        <div v-if="isEditable" class="flex justify-between pl-2 items-center">
            <input @change="updateUrl" type="url" v-model="websiteUrl" class="border p-1 m-1 w-full">
        </div>
        <div class="pl-2" v-else>
            <a :href="companyWebsite" target="_blank" class="text-blue-500 underline p-1">{{ company.website_url }}</a> 
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, computed, watch } from 'vue';

const props = defineProps([
    'company',
    'isEditable'
])

const emit = defineEmits(['update-url'])

const websiteUrl = ref(props.company ? props.company.website_url : null)

watch(props, () => {
    if(props.company){
        websiteUrl.value = props.company.website_url
    }
})

const hasUnsavedChanges = computed(() => {
    return props.company && (props.company.original_website_url != props.company.website_url || props.company.original_url_vetted_by != props.company.url_vetted_by)
})

const companyWebsite = computed(() => {
    if(props.company){
        let website = props.company.website_url
        if(website.startsWith('https')){
            return website
        }
        else if(website.startsWith('http')){
            website = website.replace('http', 'https')
            return website
        } else {
            return 'https://' + website
        }
    } else {
        return '#'
    }
})

function updateUrl(){
    emit('update-url', websiteUrl.value)
}


</script>